var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcEdit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "fdsfsdfadsfasd",
    d: "M0 9.5V12h2.5l7.373-7.373-2.5-2.5L0 9.5zm11.807-6.807c.26-.26.26-.68 0-.94l-1.56-1.56c-.26-.26-.68-.26-.94 0l-1.22 1.22 2.5 2.5 1.22-1.22z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vcxvcxvxcvzcxv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fdsfsdfadsfasd"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1890FF",
    mask: "url(#vcxvcxvxcvzcxv)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H33.333V33.333H0z",
    transform: "translate(-10.667 -10.667)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-edit.d06974dd.svg";
export { ForwardRef as ReactComponent };